// extracted by mini-css-extract-plugin
module.exports = {"DashboardWrapper":"Dashboard_DashboardWrapper__2oTOa","Loading":"Dashboard_Loading__2nufo","main-panel":"Dashboard_main-panel__3WRjd"};